import React from 'react';
import { Section, Image, TeslaText as Text, TeslaButton as Button } from 'components';

import * as styles from './styles.module.scss';

const HeaderGfv = (props) => {
  const { data } = props;
  const { primary } = data;
  const { background_image: backgroundImage, title, body1, btn_text: btnText, link } = primary;

  const hasBackgroundImage = backgroundImage?.url;
  const hasCta = btnText?.text && link?.url;

  return (
    <Section sliceName="HeaderGfv" className={styles.section} noContainer>
      <div className={styles.container}>
        <div className={styles.content}>
          <Text className={styles.title} html={title.html} text={title.text} />
          <Text className={styles.body} html={body1.html} text={body1.text} />
          {hasCta && (
            <Button to={link.url} theme="yellow">
              {btnText.text}
            </Button>
          )}
        </div>
      </div>
      {hasBackgroundImage && <Image image={backgroundImage} className={styles.image} />}
    </Section>
  );
};

export default HeaderGfv;
